<template>
    <div class="backend-container">
        <div class="desktop-container">
            <div class="block-60"></div>
            <div class="main-container">
                <div class="left-container">
                    <div class="developer-container">
                        <img :src="'/static/img'+developer.header" class="header-img" @click="clickMenu(8)" alt="">
                        <div class="developer-info">
                            <div class="name">{{developer.name}}</div>
                            <div class="phone-container">
                                <div class="phone-no">{{developer.mobile}}</div>
                                <div class="quit" @click="logout">退出</div>
                            </div>
                        </div>
                    </div>
                    <div class="menus">
                        <div class="menu" :class="item.active?'active':''" v-for="item in menus" :key="item.label"
                            @click="menuClick(item)">
                            <div class="iconfont" :class="item.icon"></div>
                            <div class="menu-label">{{item.label}}</div>
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <div>
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>开放平台</el-breadcrumb-item>
                            <el-breadcrumb-item>首页</el-breadcrumb-item>
                            <el-breadcrumb-item v-if="breadcrumb">{{breadcrumb}}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="right-main">
                        <router-view v-on:jump="jump" v-on:clickMenu="clickMenu" v-on:changeHeader="changeHeader"
                            v-on:changeName="changeName"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            developer: null,
            menus: [{
                icon: "icon-shouye",
                label: "首 页",
                path: "/backend/index",
                active: true
            }, {
                icon: "icon-dayinji",
                label: "设备管理",
                path: "/backend/printer",
                active: false
            }, {
                icon: "icon-ceshi",
                label: "打印测试",
                path: "/backend/printTest",
                active: false
            }, {
                icon: "icon-jilu",
                label: "打印记录",
                path: "/backend/printRecord",
                active: false
            }, {
                icon: "icon-sim",
                label: "机载物联卡",
                path: "/backend/sim",
                active: false
            }, {
                icon: "icon-deposit",
                label: "充值记录",
                path: "/backend/deposit",
                active: false
            }, {
                icon: "icon-huidiao",
                label: "回调地址设置",
                path: "/backend/callback",
                active: false
            }, {
                icon: "icon-desktop",
                label: "登录日志",
                path: "/backend/log",
                active: false
            }, {
                icon: "icon-yonghu",
                label: "个人中心",
                path: "/backend/center",
                active: false
            }],
            breadcrumb: ""
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        if (!loginInfoStr) {
            this.$router.push("/login");
        } else {
            this.developer = JSON.parse(loginInfoStr).developer;
        }
        if (this.$route.path != "/backend/index") {
            for (let i = 0; i < this.menus.length; i++) {
                if (this.$route.path == this.menus[i].path) {
                    this.setMenuActive(this.menus[i]);
                    break;
                }
            }
        }
    },
    methods: {
        jump(path) {
            this.$parent.$refs.header.jump(path);
            setTimeout(() => {
                this.$parent.$refs.openapi.showCallback();
            }, 200);
        },
        clickMenu(menuIndex) {
            this.menuClick(this.menus[menuIndex]);
        },
        logout() {
            sessionStorage.removeItem("loginInfo");
            this.$router.push("/login");
        },
        setMenuActive(menu) {
            for (let i = 0; i < this.menus.length; i++) {
                if (this.menus[i].active) {
                    this.menus[i].active = false;
                    break;
                }
            }
            menu.active = true;
            if (menu.label != "首 页") {
                this.breadcrumb = menu.label;
            } else {
                this.breadcrumb = "";
            }
        },
        menuClick(item) {
            if (!item.active) {
                this.setMenuActive(item);
                // 路由跳转
                this.$router.push(item.path);
            }
        },
        changeHeader(header) {
            this.developer.header = header;
        },
        changeName(name) {
            this.developer.name = name;
        }
    }
}
</script>


<style scoped>
.backend-container {
    background-color: black;
}

.desktop-container {
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
}

.main-container {
    flex: 1;
    display: flex;
    overflow-y: hidden;
    overflow-x: hidden;
}

.left-container {
    width: 245px;
    height: 100%;
    text-align: left;
    background-color: #393D49;
    color: #fff;
}

.developer-container {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid #C0C6CC;
}

.header-img {
    width: 45px;
    border-radius: 5px;
    cursor: pointer;
}

.developer-info {
    margin-left: 10px;
    color: #fff;
}

.name {
    font-weight: bold;
    font-size: 16px;
    height: 20px;
    line-height: 20px;
    width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.phone-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    height: 14px;
    line-height: 14px;
}

.phone-no {
    flex: 1;
}

.quit {
    background-color: red;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 4px;
}

.menus {
    padding: 15px;
    margin-top: 15px;
}

.iconfont {
    font-size: 20px !important;
}

.menu {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.active {
    color: #FF6700;
}

.menu+.menu {
    margin-top: 30px;
}

.menu-label {
    margin-left: 10px;
    font-size: 16px;
}

.right-container {
    flex: 1;
    padding: 15px 5px 15px 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.right-main {
    margin-top: 15px;
    flex: 1;
    width: 100%;
    text-align: left;
    overflow-y: hidden;
}
</style>


// WEBPACK FOOTER //
// backend.vue?5f681c08